import { createSelector } from '@reduxjs/toolkit';
import { GET_FEEDS } from '../../actions/feeds';
import { RootState } from '../../store';

const selectRootLoader = ({ loaders }: RootState) => loaders;

export const selectGetFeedsLoader = createSelector(
    selectRootLoader,
    loaders => loaders[GET_FEEDS],
);

export const selectFeeds = (state: RootState) => state.feeds.feeds;
